import React, { useEffect, useState } from 'react';
import * as THREE from 'three';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { STLLoader } from 'three/examples/jsm/loaders/STLLoader';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { MODEL_BASE_URL, TEXTURE_BASE_URL, CONTENT_URL } from './business/action/api'

var loader = new THREE.ObjectLoader();
var objLoader = new OBJLoader()
var stlLoader = new STLLoader()
//THREE.crossOrigin = 'anonymous'

class WebglPlayer extends React.Component {
  constructor(props) {
    super();
    this.container = null;
    this.camera = null;
    this.scene = null;
    this.renderer = null;
    this.group = null;
    this.object = null;
    this.textures = [];
    this.materials = {}
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerWidth <= 768 ? window.innerHeight * .6 : window.innerHeight;
    this.renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true, preserveDrawingBuffer: true });
    this.renderer.setClearColor(0xffffff, 0);
    this.renderer.setPixelRatio(1);
    this.renderer.setSize(this.innerWidth, this.innerHeight);
    this.renderer.shadowMap.enabled = true;
    this.scene = new THREE.Scene();
    this.scene.background = new THREE.Color(0xcce0ff);
    this.scene.fog = new THREE.Fog(0xcce0ff, 1, 1000);

    this.group = new THREE.Object3D();
    this.scene.add(this.group);

    var groundTexture = new THREE.TextureLoader().load(`${TEXTURE_BASE_URL}textures/grasslight-big.jpg`);
    groundTexture.wrapS = groundTexture.wrapT = THREE.RepeatWrapping;
    groundTexture.repeat.set(500, 500);
    groundTexture.anisotropy = 16;
    groundTexture.encoding = THREE.sRGBEncoding;
    this.groundMaterial = new THREE.MeshLambertMaterial({ map: groundTexture });

    //this.groundMaterial.side = THREE.DoubleSide
    var mesh = new THREE.Mesh(new THREE.PlaneBufferGeometry(500, 500), this.groundMaterial);
    mesh.position.y = - 2;
    mesh.rotation.x = - Math.PI / 2;
    mesh.receiveShadow = true;
    //this.scene.add(mesh);

    props.data.lights.map(light => {
      this.scene.add(loader.parseObject(light));
    })
    //
    this.state = { questions: props.questions, stepValue: 0 }

  }
  queTexture = (texture) => {
    if (!this.currentlyLoadingTexture) {
      this.textures.push(texture)
    } else {
      this.loadNextTexture(texture)
    }
  }
  loadNextTexture = (child) => {
    //this.loadedTextures
    let textureLoader = new THREE.TextureLoader();
    textureLoader.load(child.texture, (texture) => {
      child.material.map = texture;
      child.material.needsUpdate = true;
      this.startLoadingTextures()
    })
  }
  startLoadingTextures = () => {
    console.log(this.textures)
    if (this.textures.length) {
      this.loadNextTexture(this.textures.pop())
    }
  }
  componentDidMount = () => {
    this.container.appendChild(this.renderer.domElement);
    this.camera = this.createCamera(loader.parse(this.props.data.camera));
    //this.camera = new THREE.PerspectiveCamera(50, this.innerWidth  / this.innerHeight, 1, 12000);
    //this.camera.position.set(1000, 50, 1500);
    this.controls = new OrbitControls(this.camera, this.renderer.domElement);
    //this.controls.maxPolarAngle = Math.PI * 0.50;
    this.controls.minDistance = 20;
    this.controls.maxDistance = 40;
    this.controls.panSpeed = 1;
    this.controls.rotateSpeed = 1;
    objLoader.setPath(MODEL_BASE_URL);
    objLoader.load(this.props.data.model.src, (data) => {
      data.traverse((child) => {
        if (child instanceof THREE.Mesh) {
          var path = `tshirt_[Diffuse]`
          let material = new THREE.MeshPhongMaterial();
          material.shininess = 1;
          material.side = THREE.DoubleSide
          material.map = new THREE.TextureLoader().load(`${TEXTURE_BASE_URL}${path}.png`);
          this.materials[path] = material;
          //material.aoMap = new THREE.TextureLoader().load(`textures/${path}_AO.png`)
          material.normalMap = new THREE.TextureLoader().load(`${TEXTURE_BASE_URL}tshirt_[Normal].png`)
          let mesh = new THREE.Mesh(child.geometry, material);
          //mesh.receiveShadow = true;
          // mesh.castShadow = true;
          this.group.add(mesh);
        }
      });
      this.object = this.group;
      this.object.scale.x = .01;
      this.object.scale.y = .01;
      this.object.scale.z = .01;
      this.object.position.y = -13
      //this.object.position.z = 10
    });

    this.renderer.setAnimationLoop(this.animate);
    window.addEventListener('resize', () => this.onWindowResize())
  }
  createCamera = (value) => {
    this.camera = value;
    this.camera.aspect = this.innerWidth / this.innerHeight;
    this.camera.updateProjectionMatrix();
    return this.camera;
  }
  animate = () => { this.renderer.render(this.scene, this.camera); }
  onWindowResize = () => {
    this.camera.aspect = this.innerWidth / this.innerHeight;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(this.innerWidth, this.innerHeight);
  }
  render = () => {
    return (
      <div style={{ width: window.innerWidth, height: window.innerHeight }}>
        <div className={'configurable'}>
          <div className={'model-wrapper'}>
            <div style={{ width: "100%", height: "100%" }} ref={thisNode => this.container = thisNode}>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



export default WebglPlayer;